import axios from "axios";
import { CancelPlacementRequest, CreatePlacementRequest, PlacementDoc, PlacementRequest, PlacementRequestReceiverResponse } from "../models/placements";
import apiClient from "./api";

export const getPlacementDocuments = async (organizationName?: string | string[], moduleID?: number | number[], userGroupID?: number | number[], userID?: number , listIndex?: number, searchString?: string): Promise<any> => {
    let params = new URLSearchParams();

    if (Array.isArray(organizationName)) {
        organizationName.forEach(name => params.append('organizationName', name.toString()));
    } else if (organizationName !== undefined) {
        params.append('organizationName', organizationName.toString());
    }

    if (Array.isArray(moduleID)) {
        moduleID.forEach(id => params.append('moduleID', id.toString()));
    } else if (moduleID !== undefined) {
        params.append('moduleID', moduleID.toString());
    }

    if (Array.isArray(userGroupID)) {
        userGroupID.forEach(id => params.append('userGroupID', id.toString()));
    } else if (userGroupID !== undefined) {
        params.append('userGroupID', userGroupID.toString());
    }
    
    // Only append listIndex if it has a value
    if (listIndex !== undefined) {
        params.append('listIndex', listIndex.toString());
    }

    if ( userID !== undefined) {
        params.append('userID', userID.toString());
    }

    if (searchString) {
        params.append('searchString', searchString);
    }

    const response = await apiClient.get(`/placementdocument/`, { params });

    return response.data;
}

export const getSupplierPlacementDocuments = async (moduleID: number | number[], listIndex?: number): Promise<any> => {

  let params = new URLSearchParams();

  if (Array.isArray(moduleID)) {
      moduleID.forEach(id => params.append('moduleID', id.toString()));
  } else if (moduleID !== undefined) {
      params.append('moduleID', moduleID.toString());
  }

  if (listIndex !== undefined) {
      params.append('listIndex', listIndex.toString());
  }

  const response = await apiClient.get(`/placementdocument/supplier`, { params });

  return response.data;
}

export const createPlacementDocument = async (placement: PlacementDoc): Promise<any> => {
  const response = await apiClient.post(`/placementdocument/`, placement, { responseType: 'text' as 'json' });
  return response.data;
}

export const getPlacement = async (id: string): Promise<PlacementDoc> => {
  const response = await apiClient.get(`/placementdocument/${id}`);
  return response.data;
}

export const getPlacementByToken = async (token: string): Promise<PlacementDoc> => {
  const response = await apiClient.get(`/placementdocument/token/${token}`);
  return response.data;
}

export const updatePlacement = async (placement: PlacementDoc, id: string): Promise<any> => {
    const response = await apiClient.put(`/placementdocument/${id}`, placement, { responseType: 'text' as 'json' });

    return response.data;
}

export const updatePlacementDocumentByToken = async (placement: PlacementDoc, token: string): Promise<any> => {
    const response = await apiClient.put(`/placementdocument/token/${token}`, placement, { responseType: 'text' as 'json' });
    
    return response.data;
}

export const deletePlacementDocument = async (placementDocID: string): Promise<any> => {
    const response = await apiClient.delete(`/placementdocument/${placementDocID}`);
    
    return response.data;
}

export const getPlacementRequest = async (docID: string): Promise<PlacementRequest> => {
  const response = await apiClient.get(`/placementrequest/placementRequestDocument/${docID}`);

  return response.data;
}

export const getPlacementRequestByToken = async (token: string): Promise<PlacementRequest> => {
  const response = await apiClient.get(`/placementrequest/token/${token}`);

  return response.data;
}

export const createPlacementRequest = async (placementRequest: CreatePlacementRequest): Promise<any> => {
  const response = await apiClient.post(`/placementrequest/`, placementRequest, { responseType: 'text' as 'json' });

  return response.data;
}

export const updatePlacementRequestReceiver = async (id: number, answer: PlacementRequestReceiverResponse): Promise<any> => {
  const response = await apiClient.put(`/placementrequestreceiver/${id}`, answer, { responseType: 'text' as 'json' });

  return response.data;
}

export const updatePlacementRequestReceiverByToken = async (token: string, answer: PlacementRequestReceiverResponse): Promise<any> => {
  const response = await apiClient.put(`/placementrequestreceiver/token/${token}`, answer, { responseType: 'text' as 'json' });

  return response.data;
}

export const cancelPlacementRequest = async (cancelPlacementRequest: CancelPlacementRequest): Promise<any> => {
  const response = await apiClient.post(`/placementrequest/cancel`, cancelPlacementRequest, { responseType: 'text' as 'json' });

  return response.data;
}